import React, { useState,useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom';

import { Col, Container, Row } from 'reactstrap';
import Footer_m from './Footer_m';
import { instance } from './common';
import ServiceAll from './ServiceAll';
import MainSlide_m from './MainSlide_m';
import queryString from 'query-string'
import icon_1 from './img/icon_1.png';
import icon_2 from './img/icon_2.png';
import icon_3 from './img/icon_3.png';
import icon_4 from './img/icon_4.png';
import icon_5 from './img/icon_5.png';



function DrawInfo({ goPage, history, type }) {
    // FIXME: change into states
    const myinfo = JSON.parse(window.sessionStorage.result);
    const { u_login_id,u_nick,u_type,u_dealer_agency } = myinfo;
    let field;
    let represent;    
    if(u_type === '일반고객' || u_type === '총판' || u_type === '클라이언트' || u_type === '시공지점'){ // FIXME: u_type 시공지점도 여기?? r_id 계속 넘겨주는건가?
        field = 'c.co_user_id';
        represent = 'rep.represent';
    }else if(u_type === '카마스터'){
        field = 'c.co_user_id2';
        represent = 'rep.represent2';
    }
    const [data, setData] = useState([]);
    const [data2, setData2] = useState('-');
    let obj = {
        u_id:u_login_id,
        field:field,
        represent:represent
    }
    useEffect(() => {
        
      const fetchData = async () => {
          /*
        axios.post('https://abys-service.co.kr:3001/rep_car/main_info',obj).then(function(res){
            setData(res.data);
        });
        */

        instance.post('/rep_car/main_info',obj).then(function(res){
            // console.log('instance test : ' ,res, 'but u_login id is: ', u_login_id);
            setData(res.data);
        });

        if(u_type == '카마스터'){
            instance.post('/agency/id',{ag_id:u_dealer_agency}).then(function(res){
                setData2(res.data[0].ag_address);
            });
        }

        
        
      };

      fetchData();

    }, []);

    console.log('data2 : ', data2)

    const mySize = {
        marginTop: "30px",
        marginBottom: "30px"
    }

    return (
        
        <Container style={mySize}>
            {
                data.length !== 0
                ?
                data.map(v => <Row key={v.rep_id}>
                    <Col className="p-0">
                        <div className="r_flex position-relactive">
                            <h3 className="font-weight-bold mb-3">차량정보</h3>
                            <span className="blue_text" onClick={() => goPage('/represent')}>차량변경</span>
                        </div>
    
                        <table className="table table-borderless mb-3 table_font_mobile">
                            <thead></thead>
                            <tbody>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">모델명</th>
                                    <td>{v.u_car_name}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량번호</th>
                                    <td>
                                        {
                                        u_type == '일반고객'
                                        ?v.u_car_number
                                        :<span>-</span>
                                        }
                                    </td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량 APP 등록일</th>
                                    <td>{v.u_app_date}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">연식</th>
                                    <td>{v.u_car_age}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고일</th>
                                    <td>{v.u_car_date}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고색상</th>
                                    <td>{v.u_car_color}</td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div className="mb-4">
                            <div className="r_flex mb-3">
                                <h3 className="font-weight-bold">Driver</h3>
                            </div>
                            <div name="u" className="text-lightgray pl-3">
                                <div id="item-tbody">
                                    {
                                    u_type == '일반고객'
                                    ?v.driver_name
                                    :<span>-</span> 
                                    }
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="r_flex position-relactive">
                                <h3 className="font-weight-bold mb-3">카마스터</h3>
                            </div>
                            <div className="text-lightgray pl-3 mb-2" id="daeri">{v.u_address1}</div>
                            <div name="u" className="text-lightgray pl-3">
                                <div id="item-tbody2"></div>
                            </div>
                        </div>
    
                    </Col>
                </Row>)
                :
                <Row>
                    <Col className="p-0">
                        <div className="r_flex position-relactive">
                            <h3 className="font-weight-bold mb-3">차량정보</h3>
                            <span className="blue_text" onClick={() => goPage('/represent')}>차량변경</span>
                        </div>
    
                        <table className="table table-borderless mb-3 table_font_mobile">
                            <thead></thead>
                            <tbody>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">모델명</th>
                                    <td><span>-</span></td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량번호</th>
                                    <td>
                                        {
                                        u_type == '일반고객'
                                        ?<span>-</span>
                                        :<span>-</span>
                                        }
                                    </td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량 APP 등록일</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">연식</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고일</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고색상</th>
                                    <td>-</td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div className="mb-4">
                            <div className="r_flex mb-3">
                                <h3 className="font-weight-bold">Driver</h3>
                            </div>
                            <div name="u" className="text-lightgray pl-3">
                                <div id="item-tbody">
                                    {
                                    u_type == '일반고객'
                                    ?<span>-</span>
                                    :<span>-</span> 
                                    }
                                </div>
                            </div>
                        </div>
                        {u_type === '카마스터' && <div>
                            <div className="r_flex position-relactive">
                                <h3 className="font-weight-bold mb-3">카마스터</h3>
                            </div>
                            <div className="text-lightgray pl-3 mb-2" id="daeri">{data2}</div>
                            <div name="u" className="text-lightgray pl-3">
                                <div id="item-tbody2">{u_nick}님</div>
                            </div>
                        </div> } 
                    </Col>
                </Row>
            }
            
        </Container>
    )
}

function Content_m({ history }) {
    const { abysCategory } = useParams();
    const location = useLocation();
    const query = queryString.parse(location.search);

    const goPage = (link) => {
        if (window.sessionStorage.result) {

            history.push(link);

        } else {
            alert("권한이 없습니다.");
        }
    }

    const marginStyle = {
        marginTop: "118px",
        marginBottom: "26px"
    }

    const marginTopStyle = {
        marginTop: "50px",
        lineheight: "1.8em"
    }

    const borderDiv = {
        width: "38px",
        height: "4px",
        backgroundColor: 'red',
        display: 'inline-block'
    }

    const junbi = (e) => {
        alert('권한이 없습니다');
    }

    const goLogout = () => {
        const {u_social} = JSON.parse(window.sessionStorage.result);
        history.push('/Logout?kind='+u_social);
    }

    const icon_font = {
        fontSize:'12px',
        color:'#F1F6FD'
    }

    const w40 = {
        width:'40%'
    }

    const goServiceAll = () => {
        // () => abysCategory === 'sungard' ? history.push(`/serviceAll?cate=${abysCategory}`) : (window.sessionStorage.result ? history.push(`/serviceAll?cate=${abysCategory}`) : alert('로그인 이후 가능한 서비스 입니다.'))
        // if (query.r_id) {
        //     if (!window.sessionStorage.result) {
        //         return alert('로그인 이후 가능한 서비스 입니다.');
        //     }
        //     return history.push(`/serviceAll?cate=hyundai}&r_id=${query.r_id}`);
        // }
        // history.push(`/serviceAll?cate=hyundai}`);
        // 유저가 현대캐피탈서비스를 통해 온다고 가정
        if (!window.sessionStorage.result) {
            return alert('로그인 이후 가능한 서비스 입니다.');
        }
        
        if (query.r_id) {
            return history.push(`/serviceAll?cate=hyundai}&r_id=${query.r_id}`);
        } else {
            history.push(`/serviceAll?cate=hyundai`);
        }
    }

    return (
        <>            
            <div className="m_mainpicture">
                <MainSlide_m />
            </div>
            <div className="container pt-3 pb-3" style={{background:'#2F79DA'}}>
                <div className="row text-center p-0">
                    <div className="col p-0" onClick={goServiceAll}>
                        <img src={icon_1} style={w40}/><br/>
                        <span style={icon_font}>온라인 신청</span>
                    </div>
                    <div className="col p-0" onClick={() => window.sessionStorage.result ? history.push('/repFindShop') : alert('로그인 이후 가능한 서비스 입니다.')}>
                        <img src={icon_2} style={w40}/><br/>
                        <span style={icon_font}>빠른예약</span>
                    </div>
                    <div className="col p-0" onClick={() => window.sessionStorage.result ? history.push('/myReserve') : alert('로그인 이후 가능한 서비스 입니다.')}>
                        <img src={icon_3} style={w40}/><br/>
                        <span style={icon_font}>예약확인</span>
                    </div>
                    <div className="col p-0" onClick={() => window.sessionStorage.result ? history.push('/represent') : alert('로그인 이후 가능한 서비스 입니다.')}>
                        <img src={icon_4} style={w40}/><br/>
                        <span style={icon_font}>차량관리</span>
                    </div>
                    <div className="col p-0" onClick={() => window.sessionStorage.result ? history.push('/progress') : alert('로그인 이후 가능한 서비스 입니다.')}>
                        <img src={icon_5} style={w40} /><br/>
                        <span style={icon_font}>서비스 확인</span>
                    </div>
                </div>
            </div>
            <div className="info-wrap">
                {!window.sessionStorage.result                                                        
                    ? <div className="text-center" style={marginStyle}>
                        <h2 className="text-color font-weight-bold mb-0">차량정보 | Driver | 카 마스터</h2>
                        <div style={borderDiv}></div>
                        <h5 className="text-lightgray" style={marginTopStyle}>안녕하세요 고객님,<br />회원 서비스 이용을 위해서는 로그인 해주세요.</h5>
                    </div>
                    : <DrawInfo goPage={goPage} history={history}/>

                }

            </div>
            
            <Container className="info-btn-wrap text-center p-0 mb-5">
                
                {window.sessionStorage.result
                    ? 
                    <div className="mt-4 logout-box-tag text-right pr-4">
                        <a onClick={goLogout} >로그아웃</a>
                    </div>
                    :
                    <div className="mb-5"></div>
                }
            </Container>
            <Footer_m />
        </>
    );
}





export default Content_m;